import { Box, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../../../helpers/utilityFunctions/utilityFunctions';
import { ParameterCard } from '../../../documented/ParameterCard';
import { AverageVariabilityCardData } from './averageVariabilityCardData';

interface AverageVariabilityCardProps {
  data?: AverageVariabilityCardData;
  onClick: (arg: string) => void;
}

const CardDetailTypography = styled(Typography)(() => ({
  fontSize: 14,
  padding: '0px 0px 0px 16px !important',
}));

const AverageVariabilityCardMedia = styled(CardContent)(() => ({
  display: 'flex !important',
  flexDirection: 'column',
  flexGrow: '1 !important',
}));

const PanelDisplayBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

const AverageVariabilityCard: React.FC<AverageVariabilityCardProps> = ({
  data,
  onClick,
}: AverageVariabilityCardProps) => {
  const { t } = useTranslation('cards');
  return (
    <ParameterCard
      title={t('averageVariability.title')}
      iconName="TotalSteps"
      popoverContent={t('averageVariability.popover')}
      onClick={() => onClick('_10MWT')}
      enabled={!isEmpty(data)}
    >
      <CardDetailTypography>
        {t('averageVariability.description')}
      </CardDetailTypography>
      <AverageVariabilityCardMedia>
        {data && data.value ? (
          <PanelDisplayBox>
            <Typography sx={{ fontWeight: 'bold', fontSize: 57 }}>
              {data ? Number(data.value) : 0}
            </Typography>
            <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>
              {data ? data.unit : '%'}
            </Typography>
          </PanelDisplayBox>
        ) : null}
      </AverageVariabilityCardMedia>
    </ParameterCard>
  );
};

export default AverageVariabilityCard;
